import { Component, OnInit } from '@angular/core';
import { ShuttleComponent } from '../shuttle/shuttle.component';
import {CookieService} from 'angular2-cookie/core';
import {Router} from "@angular/router";
import { shuttleService } from '../data/shuttle.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-shuttle.start',
  templateUrl: './shuttle.start.component.html',
  styleUrls: ['./shuttle.start.component.css'],

})
export class Shuttle_Start_Component extends ShuttleComponent implements OnInit {
     allRoutes;
     allStops;
     constructor(private c_cookieService:CookieService,private c_router: Router, private c_shuttleService:shuttleService,private c_location:Location) {
          super(c_cookieService,c_router,c_shuttleService,c_location);
          console.log('shuttle start constructor');
          //this.init();
     }



  ngOnInit() {
       super.ngOnInit();
       console.log('start on init');
       if(!this.shuttle){
            //alert('no shuttle');
       }
  }

}
